import VDataGridSelect from './VDataGridSelect'

export { VDataGridSelect }
export default VDataGridSelect
